<template>
  <div
    id="header-container"
    class="header-container"
    :class="{
      transparent: isTransparentHeader,
      'low-z-index': searchBarBannerIsOpen
    }"
  >
    <div :style="backgroundStyles">
      <MenuOptions v-if="!isSeasonalActive || (isSeasonalActive && hideMenuSeasonal)" />
      <MenuSeasonal
        v-else
        class="menu-seasonal"
        :hide-menu-seasonal="true"
        @closeMenuSeasonal="hideMenuSeasonal = true"
      />
    </div>
    <div class="vx-nav" :style="{ boxShadow }">
      <b-col cols="10" sm="3" class="logo-section-container">
        <LogoSection />
      </b-col>
      <b-col cols="6" class="search-bar-container">
        <div class="search-bar-wrapper" :class="{ 'hide-merch-design': !getShowingSearchBarOnTop }">
          <SearchBar :show-wrapper-border="false" :is-search="true" />
        </div>
      </b-col>
      <b-col cols="2" sm="3" class="right-side-container">
        <RightSide />
      </b-col>
    </div>
    <BottomSearchBar class="show-lg" :show-filters="showFilters" />
    <ProfileMenu />
    <Discover />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import BottomSearchBar from './BottomSearchBar';
import Discover from '@/components/Discover';
import LogoSection from './LogoSection';
import MenuSeasonal from './MenuSeasonal/index';
import MenuOptions from './MenuOptions/index';
import ProfileMenu from './ProfileMenu';
import RightSide from './RightSide';

const SearchBar = () => import('@/components/SearchBar');

export default {
  name: 'HeaderApp',
  components: {
    BottomSearchBar,
    Discover,
    LogoSection,
    MenuOptions,
    MenuSeasonal,
    ProfileMenu,
    RightSide,
    SearchBar
  },
  data: () => {
    return {
      showFilters: false,
      whiteNav: false,
      width: 0,
      hideMenuSeasonal: true
    };
  },
  computed: {
    ...mapGetters('config', ['isSeasonalActive']),
    ...mapGetters('searchBar', ['isAnyBannerOpen', 'getShowingSearchBarOnTop']),
    ...mapGetters('config', ['isTransparentHeader']),
    searchBarBannerIsOpen() {
      return this.isAnyBannerOpen && !this.getShowingSearchBarOnTop;
    },
    boxShadow() {
      return this.isTransparentHeader ? 'none' : '0px 2px 11px 3px rgba(0, 0, 0, 0.1)';
    },
    backgroundStyles() {
      return this.isSeasonalActive
        ? {
            background: 'url(https://cdn.vexels.com/img/seasonal/background-seasonal.png)',
            backgroundSize: 'cover'
          }
        : { backgroundColor: '#545454' };
    }
  },
  created: async function () {
    await this.$store.dispatch('config/SEASONAL_STATUS');
    this.hideMenuSeasonal = await this.$cookies.get('vx.hideMenuSeasonal');

    const isSearch = this.$g('SEARCH_ROUTE_NAMES').some(
      (el) => this.$router.currentRoute.name == el
    );
    this.showFilters = isSearch;

    if (!process.server && isSearch) {
      const dimension = this.$router.currentRoute.params.dimension;
      const keyword = this.$route.params.search ? this.$route.params.search.replace('-', ' ') : '';
      await this.$store.commit('searchBar/SET_ACTUAL_SEARCH', keyword);
      await this.$store.dispatch('dimensions/ACTUAL_DIMENSION', dimension);
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.width = window.innerWidth;
    }
  }
};
</script>

<style lang="scss" scoped>
.header-container {
  background-color: $white;
  z-index: 900;
  position: sticky;
  top: 0;
  width: 100%;
  transition: height 0.3s;
  &.low-z-index {
    z-index: 100;
  }
  @include lg {
    position: initial;
    width: initial;
    height: auto;
  }
  .logo-section-container {
    display: flex;
    align-items: center;
    justify-content: left;
  }
  .search-bar-container {
    display: flex;
    align-items: center;
    justify-content: center;
    @include lg {
      display: none;
    }
  }
  .right-side-contaienr {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .search-bar-wrapper {
    display: flex;
    margin-left: 10px;
    width: 100%;
    @include lg {
      display: none;
    }
  }
  .left-side {
    display: flex;
  }
  .show-lg {
    display: none;
    @include lg {
      display: flex;
    }
  }
  &.transparent {
    background-color: transparent;
    box-shadow: none;
  }
}
.vx-nav {
  display: flex;
  flex-grow: 1;
  height: 60px;
  justify-content: space-between;
  padding: 0px 5px;
}
</style>
